import axios from '@/axios.js'

export default {

  getExams() {
    return new Promise((resolve, reject) => {
    axios.get('ez/exams')
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  getExam(uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`ez/exams/${uuid}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateExam(payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`ez/exams/${payload.uuid}`, payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createExam(payload) {
    return new Promise((resolve, reject) => {
      axios.post(`ez/exams}`, payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteExam(uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`ez/exams/${uuid}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}
